export default __webpack_public_path__ + "6a35b4fcbd3f33546b302b81b7e759f3.png";